import Model from "./Model";

export default class IntegrationDefault extends Model{
    primaryKey(){
        return 'slug'
    }
    resource(){
        return 'integration-default'
    }
}